import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Auth } from "./Auth/Auth";
import { Pages } from "./Pages/Pages";
import { Public } from "./Public/pages";

const router = createBrowserRouter([Auth, Pages, ...Public]);

function Router() {
  return <RouterProvider router={router} />;
}

export default Router;
